import axios from 'axios';

/**
 * Attaches the toggle to display the forgot password form
 */
export const toggleForgotPassword = (): void => {
  const toggles = document.querySelectorAll('[data-recover-toggle]');
  if (toggles.length === 0) return;

  const classToToggle = 'hide';

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      document.querySelector('[data-recover-form]').classList.toggle(classToToggle);
      document.querySelector('[data-login-form]').classList.toggle(classToToggle);
    });
  })
}

// Being used on the forgot / reset password form
export const enabledButtonOnEmailEntered = (): void => {
  const field = document.querySelector('[data-recover-pw-email]');
  if (field) {
    const enableInput = () => {
      document.querySelector('[data-recover-pw-submit]').removeAttribute('disabled');
      field.removeEventListener('keydown', enableInput)
    }
    field.addEventListener('keydown', enableInput);
  }
}

/**
 * Logs a user out and redirects them to the recover password page
 */
export const initDisplayForgotPasswordPage = (): void => {
  const toggles = document.querySelectorAll('[data-recover-toggle]');
  if (toggles.length === 0) return;

  if (window.location.hash === '#recover') {
    document.querySelector('[data-recover-form]').classList.remove('hide');
    document.querySelector('[data-login-form]').classList.add('hide');
  }
}

/**
 * Logs a user out and redirects them to the recover password page
 */
export const initChangePassword = (): void => {
  const toggles = document.querySelectorAll('[data-change-password]');
  if (!toggles.length) return;

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      axios.get('/account/logout')
        .then(() => window.location.href = '/account/login/#recover')
        .catch((e) => console.error(e));
    });
  })
}